"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultVariant = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _CheckboxBase = _interopRequireDefault(require("../CheckboxBase"));
var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));
var _Label = _interopRequireDefault(require("../Label"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["classes", "disabled", "label", "variant", "shape", "outlined", "labelSize", "startIcon", "endIcon"];
const defaultVariant = exports.defaultVariant = 'contained';
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    colors,
    spacing,
    styles
  } = theme.busbud;
  return {
    root: {},
    disabled: {},
    containedContainer: {
      backgroundColor: colors.background.primary.opaque,
      borderRadius: styles.rounding.xl,
      padding: spacing(0.75),
      paddingRight: spacing(2)
    },
    // Styles applied to the label
    label: {
      marginLeft: spacing(0.5)
    }
  };
});
const defaultVariantShape = {
  text: 'square',
  contained: 'circle'
};
/**
 * **❗️ DEPRECATED**: Use the new `Checkbox` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-checkbox):
 *
 * ```tsx
 * import { Checkbox } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/checkboxlabel)
 *
 * @deprecated
 */
const CheckboxLabel = props => {
  const {
      classes: classesOverrides,
      disabled,
      label,
      variant = defaultVariant,
      shape,
      outlined,
      labelSize,
      startIcon,
      endIcon
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cx(classes.root, {
      [classes.containedContainer]: variant === 'contained'
    })
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    disabled: disabled,
    control: /*#__PURE__*/_react.default.createElement(_CheckboxBase.default, (0, _extends2.default)({}, other, {
      disabled: disabled,
      shape: shape || defaultVariantShape[variant],
      outlined: outlined
    })),
    label: /*#__PURE__*/_react.default.createElement(_Label.default, {
      size: labelSize,
      startIcon: startIcon,
      endIcon: endIcon,
      classes: {
        root: classes.label
      }
    }, label)
  }));
};
var _default = exports.default = CheckboxLabel;